const otpEmail = {
  subject: 'Verification code:',
  body: {
    title: 'Your one-time verification code for VoiceFill Medical:',
    expiration: 'This code will expire in 15 minutes.',
  },
};

export default otpEmail;
